import check from 'check-types';

const validateData = (data) => {
  const spec = [
    {
      key: 'et',
      type: 'object',
      children: [
        {
          key: 'categories',
          type: 'array',
        },
        {
          key: 'content',
          type: 'object',
        },
        {
          key: 'floors',
          type: 'array',
        },
        {
          key: 'shops',
          type: 'array',
        },
        {
          key: 'specialOffers',
          type: 'array',
        },
      ],
    },
    {
      key: 'en',
      type: 'object',
      children: [
        {
          key: 'categories',
          type: 'array',
        },
        {
          key: 'content',
          type: 'object',
        },
        {
          key: 'floors',
          type: 'array',
        },
        {
          key: 'shops',
          type: 'array',
        },
        {
          key: 'specialOffers',
          type: 'array',
        },
      ],
    }
  ];

  if (!data) {
    console.log('Data validation error --> ' + 'no data');
    return false;
  }

  const isInvalid = (specItem, data) => {
    const dataItem = data[specItem.key];
    const typeMatches = check[specItem.type](data[specItem.key]);
    if (!dataItem) {
      console.log('Data validation error --> ' + 'no matching key in data found for: ' + specItem.key);
    } else if (!typeMatches) {
      console.log('Data validation error --> ' + 'expected type to be ' + specItem.type + ' for ' + specItem.key);
    }
    return !(dataItem && typeMatches);
  };

  const firstInvalid = (spec, data) => {
    return spec.find((specItem) => {
      if (specItem.children) {
        return !!firstInvalid(specItem.children, data[specItem.key]);
      } else {
        return isInvalid(specItem, data);
      }
    });
  };

  const result = firstInvalid(spec, data);
  if (result) {
    console.log(result);
    return false;
  } else {
    return true;
  }
};

export default validateData;
